import { create } from 'zustand';

import type { NotificationStoreActions, NotificationStoreState } from '@/type';

const INIT_STATE: NotificationStoreState = {
  notificationRawList: [],
};

const useNotificationStore = create<
  NotificationStoreState & NotificationStoreActions
>((set, get) => {
  return {
    ...INIT_STATE,

    addRawNotification(raw) {
      set({
        notificationRawList: get().notificationRawList.concat(raw),
      });
    },

    clear() {
      set({ ...INIT_STATE });
    },

    getParsedNotificationList(parser) {
      return get().notificationRawList.map(parser);
    },

    setRawNotificationList(notificationRawList) {
      set({ notificationRawList });
    },
  };
});

export default useNotificationStore;
